import { flattenedCssVariables } from "./_theme.flattened.generated";

import type { CssVariableColorNames, StandardSpacingNames } from "./theme.generated";
import type { MarginAway } from "./theme.types";
import type { CSSProperties } from "react";

/** Creates a CSS variable to allow color customization from React. */
export const cssVariableForColor = (
	color: CssVariableColorNames | undefined,
	variableName: string,
	mergeWith?: CSSProperties,
): CSSProperties | undefined => {
	if (!color) {
		return mergeWith;
	}

	const target = mergeWith || {};
	// @ts-expect-error -- noImplicitAny: dynamic CSS variable name
	target[variableName as any] = flattenedCssVariables["color-" + color]; // eslint-disable-line @typescript-eslint/no-explicit-any

	return target;
};

/** Creates a CSS variable to allow color customization from React. */
export const cssVariableForBgColor = (
	backgroundColor: CssVariableColorNames | undefined,
	variableName: string,
	mergeWith?: CSSProperties,
): CSSProperties | undefined => {
	if (!backgroundColor) {
		return mergeWith;
	}

	const target = mergeWith || {};
	// @ts-expect-error -- noImplicitAny: dynamic CSS variable name
	target[variableName as any] = flattenedCssVariables["color-" + backgroundColor]; // eslint-disable-line @typescript-eslint/no-explicit-any

	return target;
};

export const cssVariableForBorderColor = (
	borderColor: CssVariableColorNames | undefined,
	variableName: string,
	mergeWith?: CSSProperties,
): CSSProperties | undefined => {
	if (!borderColor) {
		return mergeWith;
	}

	const target = mergeWith || {};
	// @ts-expect-error -- noImplicitAny: dynamic CSS variable name
	target[variableName as any] = flattenedCssVariables["color-" + borderColor]; // eslint-disable-line @typescript-eslint/no-explicit-any

	return target;
};

export const cssVariableForSpacing = (
	spacing: StandardSpacingNames | undefined,
	variableName: string,
	mergeWith?: CSSProperties,
): CSSProperties | undefined => {
	if (!spacing) {
		return mergeWith;
	}

	const target = mergeWith || {};
	// @ts-expect-error -- noImplicitAny: dynamic CSS variable name
	target[variableName as any] = flattenedCssVariables["spacing-" + spacing]; // eslint-disable-line @typescript-eslint/no-explicit-any

	return target;
};

export const cssVariableForMargin = (
	margin: MarginAway | undefined,
	variableName: string,
	mergeWith?: CSSProperties,
): CSSProperties | undefined => {
	if (!margin) {
		return mergeWith;
	}

	const target = mergeWith || {};
	// @ts-expect-error -- noImplicitAny: dynamic CSS variable name
	target[variableName as any] = flattenedCssVariables["spacing-" + margin]; // eslint-disable-line @typescript-eslint/no-explicit-any

	return target;
};
